export default "__VITE_ASSET__aa05d318__"